import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

// Bandeau « STAGING » affiché sur TOUTES les pages de préproduction + noindex.
// L'environnement est déterminé côté serveur (garde-fou DB) et exposé par /api/public/site-config.
export default function StagingBanner() {
  const [isStaging, setIsStaging] = useState(false);

  useEffect(() => {
    let on = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/site-config`)
      .then((r) => r.json())
      .then((d) => { if (on) { const s = d?.environment === "staging"; if (s) window.__BRIOUSE_STAGING__ = true; setIsStaging(s); } })
      .catch(() => {});
    return () => { on = false; };
  }, []);

  if (!isStaging) return null;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div
        data-testid="staging-banner"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 2147483647,
          background: "repeating-linear-gradient(45deg,#b91c1c,#b91c1c 14px,#991b1b 14px,#991b1b 28px)",
          color: "#fff",
          fontSize: "12px",
          lineHeight: 1,
          fontWeight: 700,
          letterSpacing: "0.12em",
          padding: "7px 12px",
          textAlign: "center",
          textTransform: "uppercase",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.35)",
          pointerEvents: "none",
        }}
      >
        ⚠ Environnement STAGING — données de test · aucune action réelle
      </div>
    </>
  );
}
